import React, { useState } from 'react'

import { ButtonClean, Dropdown, ToolbarButton } from '@fourthwall/components'
import { DotsHorizontalIcon } from '@fourthwall/icons'

import type { WebhookType, WebhooksListItem } from '../../Webhooks.types'
import * as S from './WebhookListItem.styled'

export type WebhookListItemProps = WebhooksListItem

export const WebhookListItem = ({
  id,
  allowedTypes,
  url,
  onUpdate,
  onRemove,
  onTest,
}: WebhookListItemProps) => {
  const [isTestDropdownOpen, setIsTestDropdownOpen] = useState(false)

  const handleTestClick = (webhookType: WebhookType) => {
    onTest(id, webhookType)
    setIsTestDropdownOpen(false)
  }

  return (
    <S.Container>
      <S.Content>
        <S.Title>{allowedTypes.map(({ label }) => label).join(', ')}</S.Title>
        <S.Url>{url}</S.Url>
        <Dropdown
          isOpen={isTestDropdownOpen}
          content={allowedTypes.map(({ type, label }) => (
            <Dropdown.Item key={type} label={label} onClick={() => handleTestClick(type)} />
          ))}
          position="bottom-start"
          onClose={() => setIsTestDropdownOpen(false)}
        >
          <ButtonClean
            label="Send test notification"
            onClick={() => setIsTestDropdownOpen(!isTestDropdownOpen)}
          />
        </Dropdown>
      </S.Content>
      <Dropdown
        content={
          <>
            <Dropdown.Item label="Update" onClick={() => onUpdate(id)} />
            <Dropdown.Item label="Remove" onClick={() => onRemove(id)} />
          </>
        }
        position="bottom-end"
      >
        <ToolbarButton icon={DotsHorizontalIcon} />
      </Dropdown>
    </S.Container>
  )
}
